import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import UploadFileIcon from "Assets/Icons/UploadFileIcon";
import "./index.css";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
export function UploadFileComponent(props: any) {
  const [files, setFiles] = useState<any>([]);

  console.log("files", files);
  const onDrop = useCallback((acceptedFiles: any) => {
    acceptedFiles.map((file: any, index: number) => {
      const reader = new FileReader();

      reader.onload = function (e) {
        setFiles((prevState: any) => [
          ...prevState,
          { id: index, src: e.target && e.target.result },
        ]);
      };

      reader.readAsDataURL(file);
      console.log("file=====", file);
      props.onSelectFile(file);
      return file;
    });
  }, []);

  const onDropRejected = useCallback((error: any) => {
    console.log("error", error);
    setFiles([]);
    props.onSelectFile(null);
  }, []);
  return (
    <div>
      <DropZone onDrop={onDrop} onDropRejected={onDropRejected} />
    </div>
  );
}
const maxLength = 2e6;

function nameLengthValidator(file: any) {
  if (file.size > maxLength) {
    return {
      code: "file-too-large",
      message: "File is larger than 2MB",
    };
  }

  return null;
}
function DropZone({ onDrop, onDropRejected }: any) {
  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    open,
    isDragAccept,
    isFocused,
    isDragReject,
    fileRejections,
  } = useDropzone({
    accept: { "application/pdf": [".pdf"] },
    maxFiles: 1,
    onDrop,
    noClick: true,
    noKeyboard: true,
    onDropRejected,
    validator: nameLengthValidator,
  });
  const { screen }: any = useWindowSize();

  const lists = acceptedFiles.map((list: any) => (
    <li
      key={list.path}
      style={{
        color: "#414141",
        fontSize: "16px",
        fontWeight: "bold",
        listStyle: "none",
      }}
    >
      {list.path}
    </li>
  ));
  const fileRejectionItems = fileRejections.map(
    ({ errors }: any, index: number) => {
      return (
        <React.Fragment key={index}>
          {errors.map((e: any) => {
            console.log("etoomay", e);
            const message =
              e.code == "file-invalid-type"
                ? "Only pdf file is supported !"
                : e.code == "too-many-files"
                ? "Too many files! Please select only one file."
                : e.message;
            return (
              <div className="errorList" key={e}>
                {e.code == "too-many-files"
                  ? index == 0
                    ? message
                    : null
                  : message}
              </div>
            );
          })}
        </React.Fragment>
      );
    }
  );

  const style: any = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <>
      {" "}
      <section className="dropbox">
        <div
          className={
            ["xxl", "xl", "lg"].includes(screen)
              ? "d-flex justify-content-center align-items-center mt-3 px-5"
              : "d-flex justify-content-center align-items-center mt-3 px-4"
          }
        >
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <UploadFileIcon className="uploadIcon" onClick={open} />
            <>
              {acceptedFiles &&
              Array.isArray(acceptedFiles) &&
              acceptedFiles.length > 0 ? (
                <div className="d-flex flex-column middle justify-content-center align-items-center uploadFileName">
                  <div className="mt-3 mb-3">{lists}</div>
                </div>
              ) : (
                <>
                  <span
                    style={{
                      color: "#414141",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    className="uploadIcon mt-4"
                    onClick={open}
                  >
                    Select a file to upload
                  </span>
                  <p
                    style={{
                      color: "#a1aeb7",
                      fontSize: "14px",
                      fontWeight: "500",
                      marginBottom: "0px",
                    }}
                  >
                    or drag and drop it here
                  </p>
                  <p
                    style={{
                      color: "#a1aeb7",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    Maximum file size 2MB (only .pdf file)
                  </p>
                </>
              )}
              {fileRejectionItems}
            </>
          </div>
        </div>
      </section>
    </>
  );
}

export function CustomProgressbar(props: any) {
  const [percent, setPercent] = useState(0);
  const { uploadFile, percentage } = props;
  useEffect(() => {
    percentage && setPercent(percentage);
  }, [percentage]);
  return (
    <div className="d-flex flex-column middle justify-content-center align-items-center">
      <div style={{ width: 150, height: 150 }}>
        <CircularProgressbar
          value={percent}
          text={props.bulkUploadFailed ? "0%" : `${percent}%`}
          strokeWidth={4}
          styles={buildStyles({
            textSize: "16px",
            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: props.bulkUploadFailed
              ? "#f5365c"
              : `rgba(0, 176, 245, ${percent / 100})`,
            textColor: props.bulkUploadFailed ? "#f5365c" : "#00b0f5",
            trailColor: "#fff",
            backgroundColor: "#fff",
          })}
        />
      </div>
      {percent == 100 ? null : (
        <h2
          style={{
            textAlign: "center",
            marginTop: "10px",
            color: "#00b0f5",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          Uploading
        </h2>
      )}
      <h4
        style={{
          textAlign: "center",
          marginTop: "10px",
          color: "#414141",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        {percent == 100 ? null : <i className="fa fa-upload" />}
        {uploadFile ? "File: " + uploadFile.name : ""}
      </h4>
      <div></div>
    </div>
  );
}
const baseStyle = {
  width: "95%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 1,
  borderRadius: 1,
  borderColor: "#AFAFAF",
  borderStyle: "dashed",
  backgroundColor: "#FFFFFF",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};
